import { UserModel } from '@core/models/users/user.model';
import { AccessRequirement } from '@core/models/access-requirement.model';
import { TablePreferencesModel } from '@core/models/preferences/table-preferences.model';
import { UserGroupsMembershipModel } from './user-groups-membership.model';

export class UserProfileModel extends UserModel {
  constructor() {
    super();
  }

  public GroupsMembership: UserGroupsMembershipModel;

  public GroupsControlled: Array<number>;

  public TablesPreferences: Array<TablePreferencesModel>;

  hasGrant(requirment: AccessRequirement): boolean {
    switch (requirment) {
      case AccessRequirement.ValidationMembership:
        return this.GroupsMembership.ValidationGroups?.length > 0;

      case AccessRequirement.PPRValidationMembership:
        return this.GroupsMembership.PPRValidationGroups?.length > 0;

      case AccessRequirement.SupervisionMembership:
        return this.GroupsMembership.SupervisionGroups?.length > 0;

      case AccessRequirement.OperationalMembership:
        return this.GroupsMembership.OperationalGroups?.length > 0;

      case AccessRequirement.NonErpMemberShip:
        return this.GroupsMembership.NonERPComptabilityGroups?.length > 0;

      case AccessRequirement.AdministrationMembership:
        return this.GroupsMembership.AdministrationGroups?.length > 0;

      case AccessRequirement.InvoiceRelatedGroupMembership:
        return this.hasAnyGrantAccessForInvoices();

      case AccessRequirement.ControlMembership:
        return this.GroupsMembership.ControlGroups?.length > 0;

      case AccessRequirement.ControlNotPPRMembership:
        return this.GroupsMembership.ControlGroupsNotPPR?.length > 0;

      case AccessRequirement.ObservationMembership:
        return this.GroupsMembership.ObservationGroups?.length > 0;

      case AccessRequirement.AnalyticalMembership:
        return this.GroupsMembership.AnalyticalGroups?.length > 0;

      case AccessRequirement.MultiMembership:
        return this.GroupsMembership.GroupTypes?.length > 1;

      case AccessRequirement.OperationContributorMembership:
        return this.GroupsMembership.OperationContributorGroups?.length > 0;

      case AccessRequirement.PPRCancelationMembership:
        return this.GroupsMembership.PPRCancelationGroups?.length > 0;
    }
  }

  hasAnyGrantAccessForInvoices(): boolean {
    return (
      this.GroupsMembership.OperationalGroups?.length > 0 ||
      this.GroupsMembership.ValidationGroups?.length > 0 ||
      this.GroupsMembership.PPRValidationGroups?.length > 0 ||
      this.GroupsMembership.PPRCancelationGroups?.length > 0 ||
      this.GroupsMembership.NonERPComptabilityGroups?.length > 0 ||
      this.GroupsMembership.ControlGroups?.length > 0 ||
      this.GroupsMembership.ObservationGroups?.length > 0 ||
      this.GroupsMembership.SupervisionGroups?.length > 0
    );
  }

  hasAnyGrantAccess(): boolean {
    return this.GroupsMembership.GroupTypes?.length > 0;
  }

  hasGroup(groupId: number): boolean {
    return this.GroupsMembership.AllGroups.includes(groupId);
  }
}
